"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import { Button } from '../../../Button/Button.mjs';
import * as Aria from 'react-aria-components';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconChevronLeft } from '../../../Icon/components/icons/IconChevronLeft.mjs';
import { IconChevronRight } from '../../../Icon/components/icons/IconChevronRight.mjs';

const CalendarHeader = () => {
  return /* @__PURE__ */ jsxs("header", { children: [
    /* @__PURE__ */ jsx(Button, { ariaSlot: "previous", variant: "plain", color: "secondary", children: /* @__PURE__ */ jsx(IconChevronLeft, {}) }),
    /* @__PURE__ */ jsx(Aria.Heading, {}),
    /* @__PURE__ */ jsx(Button, { ariaSlot: "next", variant: "plain", color: "secondary", children: /* @__PURE__ */ jsx(IconChevronRight, {}) })
  ] });
};

export { CalendarHeader, CalendarHeader as default };
//# sourceMappingURL=CalendarHeader.mjs.map
